"use client";
import * as React from "react";
import { useState } from "react";

type SecretInputFormControlProps = {
  label: string;
  value?: string;
  id: string;
  placeholder?: string;
  required?: boolean;
  maxLength?: string;
  readOnly: boolean;
  copyDoneCallback?: (info: { operation: "COPY" }) => void;
  handleChange: (event: Event) => void;
  classNames?: {
    input?: string;
  };
} & JSX.InputHTMLAttributes<HTMLInputElement>;
import CopyToClipboardButton from "../../ClipboardButton/index";
import IconButton from "../../IconButton/index";
import defaultStyles from "./index.module.css";
import Spacer from "../../Spacer/index";
import cssClassAssembler from "../../../sso/utils/cssClassAssembler";

function SecretInputFormControl(props: SecretInputFormControlProps) {
  const [isSecretShown, setIsSecretShown] = useState(() => false);

  function toggleIsSecretShown() {
    setIsSecretShown(!isSecretShown);
  }

  function onChange(event: Event) {
    props.handleChange(event);
  }

  function classes() {
    return {
      input: cssClassAssembler(props.classNames?.input, defaultStyles.input),
    };
  }

  return (
    <div className={defaultStyles.container}>
      <div className={defaultStyles.toolbar}>
        <label htmlFor={props.id} className={defaultStyles.label}>
          {props.label}
        </label>
        <div>
          <IconButton
            handleClick={toggleIsSecretShown}
            label={isSecretShown ? "Hide secret" : "Show secret"}
            icon={isSecretShown ? "EyeSlashIcon" : "EyeIcon"}
          />
          <Spacer x={0.5} />
          <CopyToClipboardButton
            text={props.value || ""}
            successCallback={props.copyDoneCallback}
          />
        </div>
      </div>
      <Spacer y={2} />
      <input
        type={isSecretShown ? "text" : "password"}
        placeholder={props.placeholder}
        value={props.value || ""}
        id={props.id}
        required={props.required}
        maxLength={props.maxLength}
        readOnly={props.readOnly}
        onChange={(event) => onChange(event)}
        className={classes().input}
      />
    </div>
  );
}

export default SecretInputFormControl;
